import React from "react";
import { Link } from "react-router-dom";

const PageHeader = () => {
  return (
    <>
      <div className="page-header">
        <h1>
          <button
            className="btn_5 mt05 float-end"
            data-bs-toggle="modal"
            data-bs-target="#addgroup"
          >
            Add Skill Set
          </button>
          Skill Set
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to={"/dashboard"}>Dashboard</Link>
          </li>
          <li className="current">
            <span>/</span> Skill Set
          </li>
        </ul>
      </div>
    </>
  );
};

export default PageHeader;
